import React, {} from 'react';
import {connect} from "react-redux";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";
import SqftCabinetAttributes from "./menuRight/SqftCabinetAttributes";
import SqftRightFeaturesGrid from "./menuRight/SqftRightFeaturesGrid";

const NavigationSidebarRight = (props) => {
  const {sqftActiveShapeId} = props;

  const isCabinet = isSFTCabinetsGroup();

  if (!isCabinet) {
    return null
  }

  return (
    <div className="sqft-nav">
      <div className={`side side-right ${sqftActiveShapeId ? 'expanded' : ''}`}>
        <SqftCabinetAttributes />
      </div>
      <SqftRightFeaturesGrid />
    </div>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSidebarRight);
